import { format } from "date-fns";
import { formatters } from "jsondiffpatch";
import type React from "react";
import "jsondiffpatch/dist/formatters-styles/html.css";
import { scrollable } from "@/common";
import { Typography } from "@mui/material";

const SingleCurrentChange = ({ change }) => {
  const getFormattedDiff = (c) => {
    let __html = "";

    try {
      __html = formatters.html.format(
        c,
        // TODO provide proper original
        {},
      );
    } catch (error) {
      console.log("MWKAWvfHB1 | error processing diff", error);
    }
    if (!__html) __html = "Error rendering diff";
    return __html;
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-nowrap items-center gap-4">
        <Typography>
          <Typography
            variant="h6"
            style={{ display: "inline-block" }}
          >
            Who:
          </Typography>{" "}
          {change.who.name}
        </Typography>
        <Typography>
          <Typography
            variant="h6"
            style={{ display: "inline-block" }}
          >
            When:
          </Typography>{" "}
          {format(new Date(change.when), "yyyy-MM-dd HH:mm:ss")}
        </Typography>
      </div>

      <div className="flex flex-col gap-2">
        {change.what.map((c, index) => (
          <div key={index} className="flex flex-col gap-1">
            <Typography variant="h4">Change #{index + 1}</Typography>

            {c.description}

            {c.diff && (
              <>
                <Typography variant="h6">Diff</Typography>
                <div dangerouslySetInnerHTML={{ __html: getFormattedDiff(c.diff) }} />
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
const Empty = () => (
  <div className="flex h-full w-full items-center justify-center">
    <Typography variant="h6">Select a change on the left</Typography>
  </div>
);

export type CurrentChangeProps = {
  currentChange: any;
};
export const CurrentChange: React.FC<CurrentChangeProps> = ({ currentChange }) => (
  <div className={`flex h-full grow ${scrollable}`}>
    {Boolean(currentChange) === false ? <Empty /> : <SingleCurrentChange change={currentChange} />}
  </div>
);
CurrentChange.displayName = "components/changeHistory/CurrentChange";
